module.exports = __webpack_public_path__ + "static/img/Group13@3xe0f1d28.png";